import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const updateService = async (token, serviceData) => {
  log("welcome in updateService")
  log(serviceData)

  if (!token) {
    alert("No token in updateService")
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    const url = `${BASE_URL}/home/update_service_api`
    log("url=" + url)

    const result = await axios.put(url, serviceData, { headers })
    log("result.data from updateService:")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in updateService:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

const useUpdateService = () => {
  return { error, updateService }
}

export default useUpdateService
